import { memo, useCallback, useEffect, useState } from 'react';
import { ImpressionProductList, useImpressionsState } from '~/shared/hooks/useImpressionsState';
import { gtmProductMapper, useFranchise, useGtm } from '~/shared/utils';
import { useSource } from '~/shared/utils/gtm';
import { ProductCardProps } from '../../ProductCard';

// This was pulled out of productCard, to reduce renders
export const ProductImpressionTracker = memo(
    ({ inView, product }: { inView: boolean } & Pick<ProductCardProps, 'product'>) => {
        const [isTracked, setIsTracked] = useState<boolean>(false);
        const add = useImpressionsState((state) => state.add);
        const { trackProductImpression } = useGtm();
        const { activeMarket = {} } = useFranchise();
        const { currency } = activeMarket;
        const { source } = useSource();

        // Even though each product card has this callback, only the last one will be
        // called because the others will die due to debounce inside useImpressionsState store
        const mapAndTrackImpressions = useCallback(
            (impressions: ImpressionProductList) => {
                trackProductImpression({
                    products: gtmProductMapper(impressions),
                    currencyCode: currency,
                    impressionSource: source,
                    categoryName: product?.category,
                });
            },
            [trackProductImpression, currency, source, product?.category]
        );

        useEffect(() => {
            if (inView && !isTracked) {
                setIsTracked(true);
                add(product, mapAndTrackImpressions);
            }
        }, [inView, isTracked, setIsTracked, product, add, mapAndTrackImpressions]);

        return null;
    }
);
